module.exports = __webpack_public_path__ + "static/img/14000115.18e84c7c.png";